import Container from "../../components/Container"
import Title from "../../components/Title"
import ArrowIcon from "/static/images/landing/icons/arrow.svg"
import tracking from "../../trackings"

import "./Faq.scss"

const content = [
  {
    question: "O que é o site de Renegociação do Itaú?",
    answer:
      "O portal de renegociação é uma plataforma online de renegociação de dívidas do Itaú. Temos como objetivo ajudar clientes do Itaú a negociar as dívidas e buscar alívio financeiro de forma simples, rápida e segura.",
  },
  {
    question:
      "Quem pode renegociar no canal? Como faço para achar minhas dívidas?",
    answer:
      "Podem renegociar clientes correntistas tanto de pessoas físicas quanto jurídicas e também clientes que possuem um Cartão Itaú ou cartões dos nossos parceiros como Credicard, Luizacred, Extra, Ponto Frio, Passaí, Marisa e Hipercard. Para fazer sua renegociação é muito fácil! Basta realizar o login no site com seu CPF, consultar as operações de crédito que podem ser renegociadas neste canal e escolher as melhores opções que cabem no seu bolso.",
  },
  {
    question: "Consigo gerar uma segunda via do meu boleto?",
    answer:
      "Sim! Vale lembrar que quando o pagamento não ocorre dentro do vencimento do boleto, o Banco Itaú cancela automaticamente o acordo. Dessa forma, você deverá fazer uma nova renegociação. Caso ainda esteja dentro do prazo e queira receber seu boleto novamente você pode entrar neste link: https://correspondenciasdigitais.itau.com.br/login",
  },
  {
    question: "Quais as vantagens desse produto?",
    answer:
      "O produto permite reequilibrar e reorganizar suas finanças, uma vez que você pode alterar o valor/quantidade de parcelas e a data de vencimento mesmo para contratos em dia. Caso esteja negativado, o produto regulariza sua situação com os órgãos de proteção ao crédito após a efetivação do pagamento do boleto da primeira parcela ou do boleto de pagamento à vista, em até 5 dias úteis.",
  },
  {
    question:
      "Em quanto tempo meu nome sai dos órgãos de restrição de crédito?",
    answer:
      "Os apontamentos cadastrais relacionados ao(s) contrato(s) negociado(s) serão retirados em até 5 dias úteis após a efetivação do acordo através do pagamento do boleto da 1ª parcela ou da quitação à vista.",
  },
]

const Faq = () => {
  return (
    <div className="landing-faq">
      <Container>
        <Title className="landing-faq__title">Como podemos te ajudar?</Title>

        {content.map((item) => {
          return (
            <details key={item.question} className="landing-faq__accordion">
              <summary
                className="landing-faq__accordion-summary"
                onClick={tracking.faqClick}
              >
                {item.question}{" "}
                <ArrowIcon className="landing-faq__summary-arrow" />
              </summary>

              <p className="landing-faq__accordion-content">{item.answer}</p>
            </details>
          )
        })}
      </Container>
    </div>
  )
}

export default Faq
